export default __webpack_public_path__ + "static/media/professional.bd0494ea.webp";